module.exports = __webpack_public_path__ + "static/media/cash_fund_2.92935b86.svg";